// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Newsletter Modal Styles */
.newsletter-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(230, 62, 150, 0.5);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 2rem;
}

.newsletter-modal {
  background-color: var(--color-secondary);
  max-width: 1000px;
  width: 100%;
  max-height: 90vh;
  overflow-y: auto;
  position: relative;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
}

.modal-close-button {
  position: absolute;
  top: 1rem;
  right: 1rem;
  background: rgba(255, 255, 255, 0.2);
  border: none;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 1.2rem;
  cursor: pointer;
  transition: background-color 0.3s ease;
  z-index: 10;
}

.modal-close-button:hover {
  background: rgba(255, 255, 255, 0.3);
}

.modal-content {
  padding: 3rem;
  color: #ffffff;
}

.modal-title {
  font-size: 3.5rem;
  font-weight: 400;
  text-align: center;
  margin: 0 0 1rem 0;
  text-transform: uppercase;
  letter-spacing: 2px;
  color: var(--color-text-white);
  font-family: var(--font-family-scrolling);
}

.modal-subtitle {
  text-align: center;
  font-size: 1.1rem;
  margin: 0 0 3rem 0;
  line-height: 1.5;
  opacity: 0.9;
}

.newsletter-form {
  width: 100%;
}

.form-section {
  display: flex;
  gap: 1rem;
  align-items: flex-start;
}

.input-section {
  flex: 0 0 300px;
  padding: 1rem;
}

.newsletter-options {
  flex: 1 1;
  padding: 1rem;
}

.section-title {
  font-size: 0.9rem;
  font-weight: bold;
  margin: 0 0 1rem 0;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.newsletter-options .section-title {
  text-decoration: underline;
}

.form-group {
  margin-bottom: 0.5rem;
}

.form-group label {
  display: block;
  font-size: 0.9rem;
  margin-bottom: 0.5rem;
  font-weight: 500;
}

.form-group input[type="text"],
.form-group input[type="email"] {
  width: 100%;
  padding: 0.6rem;
  border: none;
  font-size: 1rem;
  background: white;
  color: #333;
  box-sizing: border-box;
}

.form-group input[type="text"]:focus,
.form-group input[type="email"]:focus {
  outline: none;
  box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.5);
}

/* Error States */
.form-group input.error {
  border: 2px solid #ff4444;
  background-color: rgba(255, 68, 68, 0.1);
}

.form-group input.error:focus {
  box-shadow: 0 0 0 2px rgba(255, 68, 68, 0.5);
}

.error-message {
  display: block;
  color: #ff4444;
  font-size: 0.8rem;
  margin-top: 0.25rem;
  font-weight: 500;
}

.newsletter-error {
  margin-top: 1rem;
  padding: 0.5rem;
  background-color: rgba(255, 68, 68, 0.1);
  border-left: 3px solid #ff4444;
  text-align: center;
}

.subscribe-button {
  background: var(--color-primary);
  color: white;
  border: none;
  padding: 0.8rem 2rem;
  border-radius: 25px;
  font-size: 1rem;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s ease;
  text-transform: uppercase;
  letter-spacing: 1px;
  margin-top: 1rem;
  width: 100%;
}

.subscribe-button:hover {
  background: #B91C7C;
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
}

.checkbox-group {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.checkbox-label {
  display: flex;
  align-items: center;
  cursor: pointer;
  font-size: 0.95rem;
  line-height: 1.4;
  position: relative;
  padding-left: 2rem;
}

.checkbox-label input[type="checkbox"] {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

.checkmark {
  position: absolute;
  left: 0;
  top: 0;
  height: 18px;
  width: 18px;
  background-color: rgba(255, 255, 255, 0.2);
  border: 2px solid white;
  transition: all 0.3s ease;
}

.checkbox-label:hover .checkmark {
  background-color: rgba(255, 255, 255, 0.3);
}

.checkbox-label input[type="checkbox"]:checked ~ .checkmark {
  background-color: var(--color-primary);
  border-color: var(--color-primary);
}

.checkbox-label input[type="checkbox"]:checked {
  color: var(--color-text-secondary);
}

.checkbox-label:has(input[type="checkbox"]:checked) {
  color: var(--color-text-secondary);
}

/* Removed checkmark - no checkmark needed when selected */

/* Responsive Design */
@media (max-width: 768px) {
  .newsletter-modal-overlay {
    padding: 1rem;
  }
  
  .modal-content {
    padding: 2rem;
  }
  
  .modal-title {
    font-size: 2.8rem;
    margin-bottom: 1rem;
  }
  
  .modal-subtitle {
    font-size: 1rem;
    margin-bottom: 2rem;
  }
  
  .form-section {
    flex-direction: column;
    gap: 2rem;
  }
  
  .input-section {
    flex: none;
    width: 100%;
  }
  
  .section-title {
    font-size: 0.9rem;
  }
  
  .checkbox-label {
    font-size: 0.9rem;
  }
}

@media (max-width: 480px) {
  .modal-content {
    padding: 1.5rem;
  }
  
  .modal-title {
    font-size: 1.9rem;
    letter-spacing: 1px;
  }
  
  .modal-subtitle {
    font-size: 0.9rem;
  }
  
  .section-title {
    font-size: 0.8rem;
  }
  
  .checkbox-label {
    font-size: 0.8rem;
    padding-left: 1.5rem;
  }
  
  .checkmark {
    height: 16px;
    width: 16px;
  }
}

/* Loading and Message States */
.subscribe-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

.subscribe-button:disabled:hover {
  background: var(--color-primary);
  transform: none;
  box-shadow: none;
}

.submit-message {
  margin-top: 1rem;
  padding: 0.75rem;
  border-radius: 4px;
  font-size: 0.9rem;
  font-weight: 500;
  text-align: center;
  animation: fadeIn 0.3s ease-in-out;
}

.submit-message.success {
  background-color: rgba(34, 197, 94, 0.1);
  border: 1px solid rgba(34, 197, 94, 0.3);
  color: #22c55e;
}

.submit-message.warning {
  background-color: rgba(251, 191, 36, 0.1);
  border: 1px solid rgba(251, 191, 36, 0.3);
  color: #fbbf24;
}

.submit-message.error {
  background-color: rgba(239, 68, 68, 0.1);
  border: 1px solid rgba(239, 68, 68, 0.3);
  color: #ef4444;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
} `, "",{"version":3,"sources":["webpack://./src/components/NewsletterModal/NewsletterModal.css"],"names":[],"mappings":"AAAA,4BAA4B;AAC5B;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,yCAAyC;EACzC,2BAA2B;EAC3B,mCAAmC;EACnC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,wCAAwC;EACxC,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,oCAAoC;EACpC,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,sCAAsC;EACtC,WAAW;AACb;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,8BAA8B;EAC9B,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,aAAa;AACf;;AAEA;EACE,SAAO;EACP,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,sBAAsB;AACxB;;AAEA;;EAEE,aAAa;EACb,8CAA8C;AAChD;;AAEA,iBAAiB;AACjB;EACE,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,cAAc;EACd,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,wCAAwC;EACxC,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,YAAY;EACZ,WAAW;EACX,0CAA0C;EAC1C,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,sCAAsC;EACtC,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA,0DAA0D;;AAE1D,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,UAAU;IACV,WAAW;EACb;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,YAAY;IACZ,WAAW;EACb;AACF;;AAEA,+BAA+B;AAC/B;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,wCAAwC;EACxC,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,yCAAyC;EACzC,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,wCAAwC;EACxC,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF","sourcesContent":["/* Newsletter Modal Styles */\n.newsletter-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(230, 62, 150, 0.5);\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  padding: 2rem;\n}\n\n.newsletter-modal {\n  background-color: var(--color-secondary);\n  max-width: 1000px;\n  width: 100%;\n  max-height: 90vh;\n  overflow-y: auto;\n  position: relative;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);\n}\n\n.modal-close-button {\n  position: absolute;\n  top: 1rem;\n  right: 1rem;\n  background: rgba(255, 255, 255, 0.2);\n  border: none;\n  border-radius: 50%;\n  width: 40px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: white;\n  font-size: 1.2rem;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n  z-index: 10;\n}\n\n.modal-close-button:hover {\n  background: rgba(255, 255, 255, 0.3);\n}\n\n.modal-content {\n  padding: 3rem;\n  color: #ffffff;\n}\n\n.modal-title {\n  font-size: 3.5rem;\n  font-weight: 400;\n  text-align: center;\n  margin: 0 0 1rem 0;\n  text-transform: uppercase;\n  letter-spacing: 2px;\n  color: var(--color-text-white);\n  font-family: var(--font-family-scrolling);\n}\n\n.modal-subtitle {\n  text-align: center;\n  font-size: 1.1rem;\n  margin: 0 0 3rem 0;\n  line-height: 1.5;\n  opacity: 0.9;\n}\n\n.newsletter-form {\n  width: 100%;\n}\n\n.form-section {\n  display: flex;\n  gap: 1rem;\n  align-items: flex-start;\n}\n\n.input-section {\n  flex: 0 0 300px;\n  padding: 1rem;\n}\n\n.newsletter-options {\n  flex: 1;\n  padding: 1rem;\n}\n\n.section-title {\n  font-size: 0.9rem;\n  font-weight: bold;\n  margin: 0 0 1rem 0;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n}\n\n.newsletter-options .section-title {\n  text-decoration: underline;\n}\n\n.form-group {\n  margin-bottom: 0.5rem;\n}\n\n.form-group label {\n  display: block;\n  font-size: 0.9rem;\n  margin-bottom: 0.5rem;\n  font-weight: 500;\n}\n\n.form-group input[type=\"text\"],\n.form-group input[type=\"email\"] {\n  width: 100%;\n  padding: 0.6rem;\n  border: none;\n  font-size: 1rem;\n  background: white;\n  color: #333;\n  box-sizing: border-box;\n}\n\n.form-group input[type=\"text\"]:focus,\n.form-group input[type=\"email\"]:focus {\n  outline: none;\n  box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.5);\n}\n\n/* Error States */\n.form-group input.error {\n  border: 2px solid #ff4444;\n  background-color: rgba(255, 68, 68, 0.1);\n}\n\n.form-group input.error:focus {\n  box-shadow: 0 0 0 2px rgba(255, 68, 68, 0.5);\n}\n\n.error-message {\n  display: block;\n  color: #ff4444;\n  font-size: 0.8rem;\n  margin-top: 0.25rem;\n  font-weight: 500;\n}\n\n.newsletter-error {\n  margin-top: 1rem;\n  padding: 0.5rem;\n  background-color: rgba(255, 68, 68, 0.1);\n  border-left: 3px solid #ff4444;\n  text-align: center;\n}\n\n.subscribe-button {\n  background: var(--color-primary);\n  color: white;\n  border: none;\n  padding: 0.8rem 2rem;\n  border-radius: 25px;\n  font-size: 1rem;\n  font-weight: bold;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  margin-top: 1rem;\n  width: 100%;\n}\n\n.subscribe-button:hover {\n  background: #B91C7C;\n  transform: translateY(-2px);\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);\n}\n\n.checkbox-group {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n}\n\n.checkbox-label {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  font-size: 0.95rem;\n  line-height: 1.4;\n  position: relative;\n  padding-left: 2rem;\n}\n\n.checkbox-label input[type=\"checkbox\"] {\n  position: absolute;\n  opacity: 0;\n  cursor: pointer;\n}\n\n.checkmark {\n  position: absolute;\n  left: 0;\n  top: 0;\n  height: 18px;\n  width: 18px;\n  background-color: rgba(255, 255, 255, 0.2);\n  border: 2px solid white;\n  transition: all 0.3s ease;\n}\n\n.checkbox-label:hover .checkmark {\n  background-color: rgba(255, 255, 255, 0.3);\n}\n\n.checkbox-label input[type=\"checkbox\"]:checked ~ .checkmark {\n  background-color: var(--color-primary);\n  border-color: var(--color-primary);\n}\n\n.checkbox-label input[type=\"checkbox\"]:checked {\n  color: var(--color-text-secondary);\n}\n\n.checkbox-label:has(input[type=\"checkbox\"]:checked) {\n  color: var(--color-text-secondary);\n}\n\n/* Removed checkmark - no checkmark needed when selected */\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .newsletter-modal-overlay {\n    padding: 1rem;\n  }\n  \n  .modal-content {\n    padding: 2rem;\n  }\n  \n  .modal-title {\n    font-size: 2.8rem;\n    margin-bottom: 1rem;\n  }\n  \n  .modal-subtitle {\n    font-size: 1rem;\n    margin-bottom: 2rem;\n  }\n  \n  .form-section {\n    flex-direction: column;\n    gap: 2rem;\n  }\n  \n  .input-section {\n    flex: none;\n    width: 100%;\n  }\n  \n  .section-title {\n    font-size: 0.9rem;\n  }\n  \n  .checkbox-label {\n    font-size: 0.9rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .modal-content {\n    padding: 1.5rem;\n  }\n  \n  .modal-title {\n    font-size: 1.9rem;\n    letter-spacing: 1px;\n  }\n  \n  .modal-subtitle {\n    font-size: 0.9rem;\n  }\n  \n  .section-title {\n    font-size: 0.8rem;\n  }\n  \n  .checkbox-label {\n    font-size: 0.8rem;\n    padding-left: 1.5rem;\n  }\n  \n  .checkmark {\n    height: 16px;\n    width: 16px;\n  }\n}\n\n/* Loading and Message States */\n.subscribe-button:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.subscribe-button:disabled:hover {\n  background: var(--color-primary);\n  transform: none;\n  box-shadow: none;\n}\n\n.submit-message {\n  margin-top: 1rem;\n  padding: 0.75rem;\n  border-radius: 4px;\n  font-size: 0.9rem;\n  font-weight: 500;\n  text-align: center;\n  animation: fadeIn 0.3s ease-in-out;\n}\n\n.submit-message.success {\n  background-color: rgba(34, 197, 94, 0.1);\n  border: 1px solid rgba(34, 197, 94, 0.3);\n  color: #22c55e;\n}\n\n.submit-message.warning {\n  background-color: rgba(251, 191, 36, 0.1);\n  border: 1px solid rgba(251, 191, 36, 0.3);\n  color: #fbbf24;\n}\n\n.submit-message.error {\n  background-color: rgba(239, 68, 68, 0.1);\n  border: 1px solid rgba(239, 68, 68, 0.3);\n  color: #ef4444;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
